module.exports = __webpack_public_path__ + "static/img/11.a8309af.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/sp/11.png
// module id = Aosi
// module chunks = 0